import { CircularProgress } from "@mui/material";
import { authService } from "@unisearch/auth";
import { swalConfirm, swalError, swalSuccess } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { useEvaluationActions } from "@_recoil/_actions";
import { evaluationAtom } from "@_recoil/_state";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { useRecoilState } from "recoil";
import EvaluationCountry from "./components/evaluation_country";
import EvaluationCourseLevel from "./components/evaluation_course_level";
import EvaluationDepartment from "./components/evaluation_department";
import EvaluationEducation from "./components/evaluation_education";
import EvaluationExam from "./components/evaluation_exam";
import EvaluationIntake from "./components/evaluation_intake.jsx";
import EvaluationObjective from "./components/evaluation_objective";
import EvaluationProgress from "./components/evaluation_progress";
import EvaluationSignup from "./components/evaluation_signup";
import EvaluationSpecialization from "./components/evaluation_specialization";
import styles from "./evaluation_form.module.scss";

export const EvaluationForm = () => {
  //loggedin User info
  const userInfo = authService.getProfileData();
  const childRef = useRef();
  const evaluationActions = useEvaluationActions();
  const router = useRouter();
  const [
    {
      is_loading,
      formStape,
      show_next,
      show_prev,

      countryPreference,
      courseLevelId,
      specializationId,
      departmentIds,
      courseIntake,
      courseExam,
      highestEducation,
      objectiveId,
      regInfo,
      is_registered,
      studentId,
    },
    setEvaluation,
  ] = useRecoilState(evaluationAtom);

  //check and add registered user id

  useEffect(() => {
    if (userInfo.userTypeSlug && userInfo.userTypeSlug == "student") {
      setEvaluation((prev) => ({
        ...prev,
        is_registered: true,
        studentId: userInfo.id,
      }));
    }
  }, []);

  //call recoil action on window laod
  useEffect(() => {
    const fetchData = async () => {
      //get country list
      await evaluationActions.getCountries().catch((error) => {
        swalError(error);
      });

      //get Course Level
      await evaluationActions.getCourseLevels().catch((error) => {
        swalError(error);
      });

      //get Height Education Level
      await evaluationActions.getheightEduLevels().catch((error) => {
        swalError(error);
      });

      //get Course Level
      await evaluationActions.getSpecializations().catch((error) => {
        swalError(error);
      });

      //get Exams
      await evaluationActions.getExams().catch((error) => {
        swalError(error);
      });

      //get Exams
      await evaluationActions.getObjective().catch((error) => {
        swalError(error);
      });
    };
    fetchData();
  }, []);

  //form submit
  const formSubmit = async () => {
    swalConfirm(
      "Your evaluation form information is correct?",
      "Are you sure",
      "Yes"
    ).then(async (res) => {
      if (res.isConfirmed) {
        let highestEdu = { ...highestEducation };
        delete highestEdu.slug;

        //profile evaluation data
        let profileEvaluation = {
          countryPreference,
          courseLevelId,
          specializationId,
          departmentIds,
          courseIntake,
          courseExam,
          highestEducation: highestEdu,
          objectiveId,
        };

        if (studentId != 0) {
          //add student id
          profileEvaluation.studentId = studentId;

          await API.post("/profile-evaluation", profileEvaluation)
            .then(async (res) => {
              if (!res.error) {
                //get new profile data
                await authService.getProfile();

                //redirect student admin
                const returnUrl = `/app/student`;
                router.push(returnUrl);
                swalSuccess("Your Profile Evaluation success completed!");
              }
              if (res.error) {
                swalError(res.messe);
              }
            })
            .catch((errors) => {
              swalError(errors, "Sorry!");
            });
        }
      }
    });
  };

  //render Next Button
  const renderNext = () => {
    if (show_next) {
      if (formStape == 9) {
        return (
          <button
            className={`btn btn-secondary btn-bg`}
            onClick={() => {
              setEvaluation((prev) => ({ ...prev, is_loading: true }));
              childRef.current.formSubmit();
              setEvaluation((prev) => ({ ...prev, is_loading: false }));
            }}
            disabled={is_loading ? true : false}
          >
            {is_loading && <CircularProgress size={20} />} Sign Up Now
          </button>
        );
      } else {
        return (
          <button
            className={`btn btn-secondary btn-bg`}
            onClick={handleNext}
            disabled={is_loading ? true : false}
          >
            Next
          </button>
        );
      }
    }
  };

  //submit Button
  const submitBtn = () => {
    if (is_registered) {
      return (
        <button
          className={`btn btn-secondary btn-bg`}
          onClick={() => formSubmit()}
          disabled={is_loading ? true : false}
        >
          Submit Now
        </button>
      );
    }
  };

  //previeous button
  const renderPrev = () => {
    if (formStape && formStape >= 2) {
      return (
        <button
          className={`${styles.btn_prev} btn btn-white btn-bg`}
          onClick={handlePrev}
        >
          Back
        </button>
      );
    }
  };

  //Handle Next
  const handleNext = () => {
    setEvaluation((prev) => ({
      ...prev,
      formStape: parseInt(formStape + 1),
    }));
  };

  //Handle Previous
  const handlePrev = () => {
    setEvaluation((prev) => ({
      ...prev,
      formStape: parseInt(formStape - 1),
    }));
  };

  //Handle Next
  const renderForm = (param) => {
    switch (param) {
      case 1:
        return <EvaluationCountry />;
      case 2:
        return <EvaluationCourseLevel />;
      case 3:
        return <EvaluationSpecialization />;
      case 4:
        return <EvaluationDepartment />;
      case 5:
        return <EvaluationIntake />;
      case 6:
        return <EvaluationExam />;
      case 7:
        return <EvaluationEducation />;
      case 8:
        return <EvaluationObjective />;
      case 9:
        return <EvaluationSignup ref={childRef} />;
      default:
        return <EvaluationCountry />;
    }
  };

  return (
    <section className={styles.section_evaluation_form}>
      <div className="container-extend">
        <div className={styles.wrapper}>
          <EvaluationProgress
            stepperState={formStape}
            is_registered={is_registered}
          />
          <div className={styles.content_wrapper}>
            <div className={styles.container}>{renderForm(formStape)}</div>
            <div className={styles.button_wrapper}>
              {renderPrev()}
              {is_registered && objectiveId && studentId !== 0 && formStape >= 8
                ? submitBtn()
                : renderNext()}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EvaluationForm;
